module.exports = __webpack_public_path__ + "img/account.3bb9c8ec.png";